import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

import useRequest from '@common/react/hooks/useRequest';

import CustomInput from '@app/components/UI/Forms/CustomInput/CustomInput';
import PasswordShowHide from '@app/components/UI/Forms/PasswordShowHide/PasswordShowHide';
import { TypeRecover } from '@app/components/UI/Login/RecoverForm/RecoverForm';
import RecoverFormLayout from '@app/components/UI/Login/RecoverFormLayout/RecoverFormLayout';
import styles from '@app/components/UI/Login/VerifyCodeAndSetPasswordForm/RecoverPasswordForm.module.scss';
import lockIcon from '@app/images/icons/lock.svg';
import mailIcon from '@app/images/icons/mail.svg';
import { AppRoute } from '@app/utils/appRoutes';

interface Props {
	data: Record<'phoneNumber', string> | Record<'email', string>;
	onChangeTypeRecover: (val: TypeRecover | null) => void;
}

const passwordRules = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;

const VerifyCodeAndSetPasswordForm: React.FC<Props> = ({ data, onChangeTypeRecover }) => {
	const request = useRequest();
	const navigate = useNavigate();

	return (
		<RecoverFormLayout
			title="Reset Password"
			initialValues={{
				code: '',
				password: '',
				passwordConfirmation: '',
			}}
			validationSchema={Yup.object({
				code: Yup.string().required('Code is a required field'),
				password: Yup.string().matches(passwordRules, { message: 'See password requirements' }).required('Password is a required field'),
				passwordConfirmation: Yup.string()
					.oneOf([Yup.ref('password'), null], 'Passwords must match')
					.required('Password confirmation is a required field'),
			})}
			onBack={() => onChangeTypeRecover(null)}
			onSubmit={(values) => (
				request((Object.keys(data).some((value) => value === 'phoneNumber') ? 'setPasswordAndLoginByPhoneNumber' : 'setPasswordAndLoginByEmail'), {
					code: values.code,
					password: values.password,
					...data,
				})
					.then((val) => {
						navigate(AppRoute.PETS);
					})
			)}
			successfulMessage="Password changed successfully!"
			render={(formikBag) => (
				<div className={styles.fields}>
					{/* START: Inputs to trick browser autofill */}
					<input type="text" autoComplete="username" style={{ display: 'none' }} />
					<input type="password" autoComplete="new-password" style={{ display: 'none' }} />
					{/* END */}

					<CustomInput
						name="code"
						placeholder="Code*"
						formikBag={formikBag}
						prefixIcon={mailIcon}
						autoComplete="new-password"
					/>
					<CustomInput
						name="password"
						placeholder="New Password*"
						formikBag={formikBag}
						removeSpace
						handleOnChange={(e) => formikBag.setFieldValue('password', e.target.value)}
						prefixIcon={lockIcon}
						component={PasswordShowHide}
						autoComplete="new-password"
					/>
					<CustomInput
						name="passwordConfirmation"
						placeholder="Repeat New Password*"
						formikBag={formikBag}
						removeSpace
						handleOnChange={(e) => formikBag.setFieldValue('passwordConfirmation', e.target.value)}
						prefixIcon={lockIcon}
						component={PasswordShowHide}
						autoComplete="new-password"
					/>
				</div>
			)}
		/>
	);
};

export default VerifyCodeAndSetPasswordForm;
